import { Svg, type SvgProps } from '../../misc/svg';

import type { JSX } from 'react';

export const TextMessage = (properties: SvgProps): JSX.Element => (
  <Svg viewBox='0 0 89 138' {...properties}>
    <g>
      <rect
        x='11.7881'
        y='0.5'
        width='77'
        height='131'
        rx='8'
        transform='rotate(4.72393 11.7881 0.5)'
        stroke='#012F33'
        strokeWidth='1.43791'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <g>
        <path
          d='M79.219 34.4827C79.4152 32.1084 77.6495 30.0245 75.2751 29.8283L42.016 27.0799C39.6417 26.8837 37.5578 28.6495 37.3616 31.0238L35.7662 50.3305C35.57 52.7048 37.3357 54.7886 39.71 54.9848L56.3396 56.359L64.147 57.0042C65.7753 57.1388 67.1879 58.1818 67.7958 59.6984L68.1747 60.6438C68.4746 61.392 69.4912 61.4961 69.9365 60.8242L70.9584 59.2822C71.6231 58.2792 72.7811 57.7177 73.9802 57.8168V57.8168C75.7962 57.9668 77.3899 56.6164 77.54 54.8004L79.219 34.4827Z'
          stroke='#012F33'
          strokeWidth='1.43791'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <rect
          width='22'
          height='3.67176e-06'
          rx='1.83588e-06'
          transform='matrix(-0.996603 -0.0823548 -0.0823548 0.996603 64.0488 35.9243)'
          stroke='#012F33'
          strokeWidth='1.43791'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <rect
          width='32'
          height='3.67176e-06'
          rx='1.83588e-06'
          transform='matrix(-0.996603 -0.0823548 -0.0823548 0.996603 73.5205 42.7275)'
          stroke='#012F33'
          strokeWidth='1.43791'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <rect
        width='22'
        height='3.67176e-06'
        rx='1.83588e-06'
        transform='matrix(-0.996603 -0.0823548 -0.0823548 0.996603 51.4062 128.197)'
        stroke='#012F33'
        strokeWidth='1.43791'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <rect
        x='71.9971'
        y='121.871'
        width='64'
        height='12'
        rx='4.31373'
        transform='rotate(-175.276 71.9971 121.871)'
        stroke='#012F33'
        strokeWidth='1.43791'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
  </Svg>
);
